/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { store as sarsaparillaStore } from 'sarsaparilla';

import rootReducer from './reducers';
import { INITIAL_LOTTERY_STATE } from '../src/reducers/lottery';

const sarsaState = sarsaparillaStore();
const initialState = {
    lottery: INITIAL_LOTTERY_STATE,
    ...sarsaState,
};

type WindowWithReduxDevTools = Window & { __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: any };

const composeEnhancer =
    (window as WindowWithReduxDevTools).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
    rootReducer,
    initialState as Parameters<typeof createStore>,
    composeEnhancer(applyMiddleware(thunk))
);

export default store;
